module.exports = __webpack_public_path__ + "img/gxmj.842c1328.jpg";